import { combineReducers } from "redux";

import authReducer from "./auth";
import userReducer from "./user";
import alertReducer from "./alert";
import notificationReducer from "./notification";
import sitesReducer from "./sites";

const rootReducer = combineReducers({
  alert: alertReducer,
  auth: authReducer,
  user: userReducer,
  notification :notificationReducer,
  sites: sitesReducer

});

export default rootReducer;